import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MobileDetect from "mobile-detect";
import { useRillContext } from "../rill/RillReact/share/base";

function ToolTip(props) {
  const {
    children,
    className,
    id,
    body,
    multiline,
    place,
    html,
    hintClassNames = "",
    float = true,
  } = props;

  const { locals } = useRillContext();

  // we never want to show tooltips on mobile, so disable them!
  const md = new MobileDetect(locals.headers["user-agent"] || "");

  return (
    <div className={className}>
      <div
        data-tooltip-content={body}
        data-tooltip-id={id}
        data-tip-disable={md.mobile() ? true : false}
        data-tooltip-html={html || null}
        data-tooltip-place={place || "top"}
      >
        {children}
      </div>
      <ReactTooltip
        id={id}
        // type={type || "dark"}
        multiline={multiline || false}
        float={float}
        className={`React-Tooltip${
          hintClassNames ? ` ${hintClassNames}` : ""
        } custom-style z-50`}
      />
    </div>
  );
}

export default ToolTip;
